import type {
  CreatePermissaoDominioDto,
  ListPermissoesDominioQuery,
  PermissaoDominio,
  UpdatePermissaoDominioDto,
} from '@/types/escritorio/permissaoDominioTypes';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { permissoesDominioService } from './services';

export const listarPermissoesDominio = createAsyncThunk(
  'permissoesDominio/listar',
  async (
    { escritorioId, filters }: { escritorioId: string; filters?: ListPermissoesDominioQuery },
    { rejectWithValue },
  ) => {
    try {
      return await permissoesDominioService.listar(escritorioId, filters);
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Erro ao listar permissões por domínio';
      return rejectWithValue(message);
    }
  },
);

export const criarPermissaoDominio = createAsyncThunk(
  'permissoesDominio/criar',
  async (
    { escritorioId, data }: { escritorioId: string; data: CreatePermissaoDominioDto },
    { rejectWithValue },
  ) => {
    try {
      return await permissoesDominioService.criar(escritorioId, data);
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Erro ao criar permissão por domínio';
      return rejectWithValue(message);
    }
  },
);

export const atualizarPermissaoDominio = createAsyncThunk(
  'permissoesDominio/atualizar',
  async (
    {
      escritorioId,
      usuarioId,
      dominio,
      data,
    }: {
      escritorioId: string;
      usuarioId: string;
      dominio: PermissaoDominio;
      data: UpdatePermissaoDominioDto;
    },
    { rejectWithValue },
  ) => {
    try {
      return await permissoesDominioService.atualizar(escritorioId, usuarioId, dominio, data);
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Erro ao atualizar permissão por domínio';
      return rejectWithValue(message);
    }
  },
);

export const removerPermissaoDominio = createAsyncThunk(
  'permissoesDominio/remover',
  async (
    {
      escritorioId,
      usuarioId,
      dominio,
    }: { escritorioId: string; usuarioId: string; dominio: PermissaoDominio },
    { rejectWithValue },
  ) => {
    try {
      await permissoesDominioService.remover(escritorioId, usuarioId, dominio);
      return { usuarioId, dominio };
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Erro ao remover permissão por domínio';
      return rejectWithValue(message);
    }
  },
);
